module.exports = __webpack_public_path__ + "img/45.222e9f66.svg";